import * as React from "react";

interface IDownloadButtonProps {
  link: string;
  downloadName?: string;
}

export default class DownloadButton extends React.PureComponent<IDownloadButtonProps> {
  render() {
    return (
      <a
        className="prveo-btn float-right prveo-btn-light"
        href={this.props.link}
        target="_blank"
        download={this.props.downloadName}
        rel="noopener noreferrer"
      >
        <svg viewBox="0 0 482.239 482.239" style={{ width: "1rem" }}>
          <path d="m0 447.793h482.239v34.446h-482.239z" />
          <path d="m396.091 223.863-24.287-24.354-113.462 113.462v-312.971h-34.446v312.971l-113.495-113.496-24.22 24.354 154.938 155.073z" />
        </svg>
      </a>
    );
  }
}
